/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBlogger = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m18.619 1 .212.005A4.381 4.381 0 0 1 23 5.381V18.62l-.005.212A4.381 4.381 0 0 1 18.619 23H5.38l-.212-.005A4.382 4.382 0 0 1 1 18.619V5.38l.005-.212A4.382 4.382 0 0 1 5.381 1zm-5.866 4H10.44c-1.68.003-1.738.013-2 .086-1.16.324-2.064 1.222-2.367 2.352-.056.21-.069.403-.071 2.796v4.216c.005 2.285.044 2.169.284 2.668.47.976 1.455 1.714 2.461 1.843.396.05 6.995.053 7.358.002a3.072 3.072 0 0 0 1.743-.837c.467-.436.76-.898.945-1.486.076-.242.087-.281.09-1.569v-1.618c-.003-1.464-.027-1.415-.266-1.661-.18-.186-.358-.257-.776-.312-.558-.072-.803-.229-.994-.631l-.099-.21-.023-1.505c-.025-1.694-.028-1.71-.322-2.306a3.39 3.39 0 0 0-2.138-1.743c-.256-.065-.332-.08-1.51-.084zM9.96 13.594h2.46c2.781.002 2.621-.015 2.936.31.261.269.323.42.323.795 0 .278-.015.352-.102.52-.115.217-.28.372-.507.476-.142.065-.315.07-2.65.07l-2.499.001-.198-.099c-.395-.197-.603-.576-.57-1.04.03-.415.253-.757.61-.935zm1.697-5.373h1.66l.19.09c.406.189.61.514.61.976 0 .465-.199.782-.61.977l-.19.09-1.676-.003c-1.354-.002-1.707-.013-1.831-.057-.38-.135-.666-.559-.666-.987 0-.329.09-.56.3-.777.278-.285.299-.308 1.79-.31z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgBlogger as Blogger };
